import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../App';
import Modal from '../../Components/Modal/Modal';
import { Button } from '../../Components/StyledComponents';
import Switch from '../../Components/Switch/Switch';
import { convertCost } from '../../Utils/functions';
import TempStop from '../Order/Info/OperationInfo/Modals/TempStop';
import TempHoliday from './TempHoliday';
import './Waiting.scss'
import WaitingSetting from './WaitingSetting';
import WaitingStatus from './WaitingStatus';
import OperationHour from './OperationHour';
import { useNavigate } from 'react-router-dom';

const Waiting = () => {
    const navigate = useNavigate();
    const [ info, setInfo ] = React.useState({})//웨이팅 정보
    const [ isActive, setIsActive ] = React.useState(false)//웨이팅 활성화 여부

    const modalRef = React.useRef(null);//웨이팅 정보 수정 모달
    const statusModalRef = React.useRef(null);
    const tempHolidayRef = React.useRef(null);//웨이팅 임시 휴일 설정
    const tempStopRef = React.useRef(null);//웨이팅 임시 정지 설정
    const operationRef = React.useRef(null);//웨이팅 운영시간 설정

    useEffect(() => {
        getInfo()
    },[])

    //웨이팅 정보 get
    const getInfo = () => {
        axios.get('/api/waiting/info')
        .then((data) => {
            if( typeof data.data.WaitingInfo !== 'undefined')setInfo(data.data.WaitingInfo)
            else navigate("/req-waiting")
            if( typeof data.data.useWaiting !== 'undefined') setIsActive(data.data.useWaiting)
        })
    }

    const convertPad = (val) => {
        return val.toString().padStart(2,'0')
    }

    //웨이팅 정보 수정
    const patchInfo = (val) => {
        axios.patch('/api/waiting/info',val)
        .then((data) => {
            getInfo();
            modalRef.current.closeModal()
            alertRef.current.showAlert({ title : '웨이팅 정보가 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const removeTempStop = () => {
        axios.delete('/api/waiting/info/temp_stop')
        .then((data) => {
            if(data.status === 204){
                getInfo();
                alertRef.current.showAlert({ title : '임시 영업 중단이 해제 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //웨이팅 활성화 상태 변경
    const patchUse = () => {
        axios.patch('/api/waiting/use')
        .then((data) => {
            if(data.status === 204){
                if(isActive) alertRef.current.showAlert({ title : '웨이팅 기능이 비활성화 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
                else alertRef.current.showAlert({ title : '웨이팅 기능이 활성화 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
                setIsActive(val => !val);
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //웨이팅 임시 영업 중단 설정
    const patchTempStop = (val) => {
        axios.patch('/api/waiting/info/temp_stop', {
            TempStop : val
        })
        .then((data) => {
            if(data.status === 204){
                getInfo();
                tempStopRef.current.closeModal();
                alertRef.current.showAlert({ title : '임시 영업 중단이 설정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //웨이팅 임시 휴무 설정
    const patchTempHoliday = (val) => {
        axios.patch('/api/waiting/info/temp_dayoffs',{
            TempDayOffs : val
        })
        .then((data) => {
            if(data.status === 204){
                getInfo();
                tempHolidayRef.current.closeModal()
                alertRef.current.showAlert({ title : '임시 휴일이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //웨이팅 운영시간 수정
    const patchOperationHours = (val) => {
        axios.patch('/api/order/info/operation_hours', {
            OperationHours : {
                Everyday : val.Allday,
                Weekday : val.Weekday,
                Saturday : val.Saturday,
                Sunday : val.Sunday
            }
        })
        .then((data) => {
            if(data.status === 204){
                getInfo();
                operationRef.current.closeModal();
                alertRef.current.showAlert({ title : '운영시간이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    function padTempStop(time){
        return '시작 : ' + String(time.StartHour).padStart(2, '0') + ' : ' + String(time.StartMin).padStart(2, '0') + ' ~ ' + '종료 : ' + String(time.EndHour).padStart(2, '0') + ' : ' + String(time.EndMin).padStart(2, '0')
    }

    return (
        <div className='wrapper waiting'>
            <div className='header-row'>
                <p className='header-text'>웨이팅 {'>'}</p>
                <p className='header'>웨이팅 관리</p>
            </div>
            
            <div className='row-auto'>
                <p className='active-text'>웨이팅 기능 사용여부</p>
                <Switch id='first' value={isActive} onChange={(val) => {patchUse()}} />
            </div>

            {/* <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>웨이팅 상태</p>
                        <p className='info-sub-title'>현재 웨이팅 상태를 확인해보세요.</p>
                    </div>
                    <Button variant="sub" className='edit-btn' onClick={() => statusModalRef.current.openModal()}>
                        수정하기
                    </Button>
                </div>

                <div className='header-divider' ></div>
                {
                    Object.keys(info).length > 0 ?
                    <div className='row'>
                        <p className='info-title'>상태</p>
                        <p className='info-text'>{isOrder ? '활성화' : '비활성화'}</p>
                    </div>
                    :
                    <>
                        <div className='row'>
                            <p className='info-text'>웨이팅 상태를 설정해 주세요.</p>
                        </div>
                    </>
                }
            </div> */}

        {/* <div className='info-box'>
            <div className='row between'>
                <div>
                    <p className='info-box-title'>운영시간</p>
                    <p className='info-sub-title'>우리 매장의 운영 시간을 설정해요.</p>
                </div>

                <Button variant="sub" className='edit-btn' onClick={() => operationRef.current.openModal()}>
                    수정하기
                </Button>
            </div>

            <div className='header-divider' ></div>
                {
                    (typeof info.OperationHours !== 'undefined' && Object.keys(info.OperationHours).length > 0) ?
                    info.OperationHours.Everyday === true ?
                    <div className='row'>
                        <p className='info-title'>모든 요일</p>
                        {
                            info.OperationHours.Weekday.Allday ?
                            <p className='info-text'>24시간 영업</p>
                            :
                            <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Weekday.OpenHour)} : {convertPad(info.OperationHours.Weekday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Weekday.CloseHour)} : {convertPad(info.OperationHours.Weekday.CloseMin)}</p>
                        }
                    </div>
                    :
                    <>
                        <div className='row' style={{ marginBottom : 16 }}>
                            <p className='info-title'>평일</p>
                            {
                                info.OperationHours.Weekday.Allday ?
                                <p className='info-text'>24시간 영업</p>
                                :
                                <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Weekday.OpenHour)} : {convertPad(info.OperationHours.Weekday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Weekday.CloseHour)} : {convertPad(info.OperationHours.Weekday.CloseMin)}</p>
                            }
                        </div>
                        <div className='row' style={{ marginBottom : 16 }}>
                            <p className='info-title'>토요일</p>
                            {
                                info.OperationHours.Saturday.Allday ?
                                <p className='info-text'>24시간 영업</p>
                                :
                                <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Saturday.OpenHour)} : {convertPad(info.OperationHours.Saturday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Saturday.CloseHour)} : {convertPad(info.OperationHours.Saturday.CloseMin)}</p>
                            }
                        </div>
                        <div className='row'>
                            <p className='info-title'>일요일</p>
                            {
                                info.OperationHours.Sunday.Allday ?
                                <p className='info-text'>24시간 영업</p>
                                :
                                <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Sunday.OpenHour)} : {convertPad(info.OperationHours.Sunday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Sunday.CloseHour)} : {convertPad(info.OperationHours.Sunday.CloseMin)}</p>
                            }
                        </div>
                    </>
                    :
                    <p className='info-text'>운영시간을 설정해 주세요.</p>
                }
            </div> */}

            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>웨이팅 정보</p>
                        <p className='info-sub-title'>우리 매장 웨이팅에 대한 정보를 입력하세요.</p>
                    </div>

                    <Button variant="sub" className='edit-btn' onClick={() => modalRef.current.openModal()}>
                        수정하기
                    </Button>
                </div>
                
                {
                    Object.keys(info).length > 0 ?
                    <>
                        <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>유아용 의자 여부</p>
                            <p className='info-text'>{ info.BabyChair ? '보유' : '미보유'}</p>
                        </div>

                        <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>대기시간 노출여부</p>
                            <p className='info-text'>{ info.ShowTime ? '노출' : '미노출'}</p>
                        </div>

                        {/* <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>자동호출 여부</p>
                            <p className='info-text'>{ info.AutoCall ? '사용' : '미사용'}</p>
                        </div> */}

                        <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>평균 대기시간</p>
                            <p className='info-text'>{convertCost(info.AvgTime)}분</p>
                        </div>

                        <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>최대 대기가능 팀</p>
                            <p className='info-text'>{convertCost(info.MaxTeam)}팀</p>
                        </div>
                        <div className='divider' ></div>
                        
                        <div className='row'>
                            <p className='info-title'>매장 공지사항</p>
                            <p className='info-text'>{info.Notice === '' ? '공지사항이 없습니다.' : info.Notice}</p>
                        </div>
                    </>
                    :
                    <>
                        <div className='divider' ></div>
                        <div className='row'>
                            <p className='info-text'>웨이팅 정보를 설정해 주세요.</p>
                        </div>
                    </>
                }
            </div>

            {/* <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>임시 영업 중단 / 임시 휴일</p>
                        <p className='info-sub-title'>임시로 영업을 잠시 중단하거나 임시 휴일을 설정해요.</p>
                    </div>
                </div>

                <div className='header-divider' ></div>
                
                <div className='row between'>
                    <div className='row'>
                        <p className='info-title'>임시 영업 중단</p>
                        {
                            ( (typeof info.TempStop !== 'undefined') && Object.keys(info.TempStop).length > 0) ?
                            <p className='info-text'>{padTempStop(info.TempStop)}</p>
                            :
                            <p className='info-text'>-</p>
                        }
                    </div>
                    {
                            (typeof info.TempStop !== 'undefined') && Object.keys(info.TempStop).length > 0 ?
                        <Button variant="main" style={{ width : 88}} small onClick={() => alertRef.current.showAlert({ title : `임시 영업 중단을 해제하시겠어요?`, isConfirm : true, confirmText : '해제', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();removeTempStop()} })}>
                            해제하기
                        </Button>
                        :
                        <Button variant="sub" className='edit-btn' onClick={() => tempStopRef.current.openModal()}>
                            설정하기
                        </Button>
                    }
                </div>
                <div className='divider' />

                <div className='row between'>
                    <div className='row'>
                        <p className='info-title'>임시 휴일</p>
                        <div>
                        {
                            ( (typeof info.TempDayOffs !== 'undefined') && Object.keys(info.TempDayOffs).length > 0 )?
                            info.TempDayOffs.map((item,i) => {
                                return(
                                    <p key={i} className='info-text'>{item.StartYear + '-' + convertPad(item.StartMonth) + '-' + convertPad(item.StartDay)} 부터 {item.EndYear + '-' + convertPad(item.EndMonth) + '-' + convertPad(item.EndDay)} 까지</p>
                                )
                            })
                            :
                            <p className='info-text'>-</p>
                        }
                        </div>
                    </div>

                    <Button variant="sub" className='edit-btn' onClick={() => tempHolidayRef.current.openModal()}>
                        수정하기
                    </Button>
                </div>
            </div> */}

            <Modal ref={statusModalRef} contentContainer={{ width : 500 }} isHeader title={'웨이팅 상태 설정하기'}>
                <WaitingStatus />
            </Modal>

            <Modal ref={operationRef} contentContainer={{ width : 449 }} isHeader title={'운영시간 설정하기'}>
                <OperationHour info={info.OperationHours} patchOperationHours={patchOperationHours}/>
            </Modal>

            <Modal ref={modalRef} contentContainer={{ width : 500 }} isHeader title={'웨이팅 정보 설정하기'}>
                <WaitingSetting info={info} patchInfo={patchInfo}/>
            </Modal>

            <Modal ref={tempHolidayRef} contentContainer={{ width : 500 }} isHeader title={'임시 휴일 설정하기'}>
                <TempHoliday tempDayOffs={info.TempDayOffs} patchTempHoliday={patchTempHoliday}/>
            </Modal>

            <Modal ref={tempStopRef} contentContainer={{ width : 500 }} isHeader title={'임시 영업 중단 설정하기'}>
                <TempStop tempDayOffs={info.TempStop} patchTempStop={patchTempStop}/>
            </Modal>
        </div>
    )
}

export default Waiting;